export default __webpack_public_path__ + "static/media/lomotey.4276ed8d.jpeg";